import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import "./school-structure.css";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { MultiSelect } from "react-multi-select-component";
import Chip from "@mui/material/Chip";
import { Model } from "./../../components";
import { useAlert } from "react-alert";
import Time from "../../../data/time";
const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#6B6B6B" : "#663399",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#6B6B6B" : "#663399",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
const SchoolStructure = () => {
  const alert = useAlert();
  const [selected, setSelected] = React.useState([]);
  const options = [
    { label: "1A", value: "1A" },
    { label: "1B", value: "1B" },
    { label: "1C", value: "1C" },
  ];
  const [chipData, setChipData] = React.useState([
    { key: 0, label: "Angular" },
    { key: 1, label: "jQuery" },
    { key: 2, label: "Polymer" },
    { key: 4, label: "Vue.js" },
  ]);

  const handleDelete = (chipToDelete) => () => {
    setChipData((chips) =>
      chips.filter((chip) => chip.key !== chipToDelete.key)
    );
  };
  const [addClassModel, setAddClassModel] = React.useState(false);
  const [timeStructure, setTimeStructure] = React.useState([
    {
      day: "MON",
      status: true,
      startTime: "09.00",
      endTime: "18.00",
      add: "Add Opening Hour",
    },
    {
      day: "TUE",
      status: true,
      startTime: "09.00",
      endTime: "18.00",
      add: "Add Opening Hour",
    },
    {
      day: "WED",
      status: true,
      startTime: "09.00",
      endTime: "18.00",
      add: "Add Opening Hour",
    },
    {
      day: "THU",
      status: true,
      startTime: "09.00",
      endTime: "18.00",
      add: "Add Opening Hour",
    },
    {
      day: "FRI",
      status: true,
      startTime: "09.00",
      endTime: "18.00",
      add: "Add Opening Hour",
    },
    {
      day: "SAT",
      status: false,
      startTime: "",
      endTime: "",
      add: "",
    },
    {
      day: "SUN",
      status: false,
      startTime: "",
      endTime: "",
      add: "",
    },
  ]);
  const AddClassTable = [
    {
      class: "Class 1st",
      divisionNo: 3,
      divisionFormate: "Alphabet",
      divisions: ["1A", "1B", "1C"],
    },
    {
      class: "Class 2nd",
      divisionNo: 2,
      divisionFormate: "Alphabet",
      divisions: ["1A", "1B", "1C"],
    },
    {
      class: "Class 3rd",
      divisionNo: 1,
      divisionFormate: "Alphabet",
      divisions: ["1A"],
    },
    {
      class: "Class 4th",
      divisionNo: 3,
      divisionFormate: "Alphabet",
      divisions: ["1A", "1B", "1C"],
    },
    {
      class: "Class 5th",
      divisionNo: 3,
      divisionFormate: "Alphabet",
      divisions: ["1A", "1B", "1C"],
    },
  ];

  // Add Class And Division
  const [classTitle, setClassTitle] = React.useState("");
  const [classDivision, setClassDivision] = React.useState("");
  const [classDivisionFormate, setClassDivisionFormate] = React.useState("");
  const [addClassLoading, setAddClassLoading] = React.useState(false);
  const classTitleRef = React.useRef();
  const classDivisionRef = React.useRef();
  const classDivisionFormateRef = React.useRef();
  const AddClassHandler = () => {
    if (classTitle === "") {
      alert.error(<div className="alert-message">add class title</div>);
      classTitleRef.current.focus();
    } else if (classDivision === "") {
      alert.error(<div className="alert-message">add division no</div>);
      classDivisionRef.current.focus();
    } else if (classDivisionFormate === "") {
      alert.error(<div className="alert-message">add division formate</div>);
      classDivisionFormateRef.current.focus();
    } else if (selected.length < 1) {
      alert.error(<div className="alert-message">select division</div>);
    } else {
      setAddClassLoading(true);
      const AddClassObject = {
        class: classTitle,
        divisionNo: classDivision,
        divisionFormate: classDivisionFormate,
        division: selected,
      };
      alert.success(
        <div className="alert-message">you have successfully added</div>
      );
      console.log(AddClassObject);
      setTimeout(() => {
        setAddClassModel(false);
        setAddClassLoading(false);
      }, 2000);
    }
  };
  return (
    <div>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xl={10} lg={10} md={10} sm={6} xs={6}></Grid>
          <Grid item xl={2} lg={2} md={2} sm={6} xs={6}>
            <Button className="header-button" variant="text">
              <p className="page-header-button-text">Save Changes</p>
            </Button>
          </Grid>
        </Grid>
      </Box>

      <a
        href="#"
        id="school-structure-add-class-button"
        onClick={() => setAddClassModel(true)}
      >
        + add New Class
      </a>
      <h1 className="school-structure-heading">Add Time Structure</h1>
      <div className="school-structure-table-container">
        <table>
          {timeStructure.map((timeStructureValue, timeStructureIndex) => {
            return (
              <tr key={timeStructureIndex}>
                <td className="school-structure-table-day">
                  {timeStructureValue.day}
                </td>
                <td className="school-structure-table-switch">
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        sx={{ m: 1 }}
                        defaultChecked={timeStructureValue.status}
                      />
                    }
                    label={timeStructureValue.status ? "Open" : "Close"}
                    onChange={() => {
                      timeStructure[timeStructureIndex].status =
                        !timeStructure[timeStructureIndex].status;
                      setTimeStructure([...timeStructure]);
                    }}
                  />
                </td>
                <td className="school-structure-table-start-time">
                  {timeStructureValue.startTime !== "" && (
                    <div className="school-structure-table-time-box">
                      <select className="school-structure-table-time-dropdown">
                        {Time.map((timeValue, timeIndex) => {
                          return (
                            <option value={timeValue.time} key={timeIndex}>
                              {timeValue.time}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  )}
                </td>
                <td className="school-structure-table-time-line">
                  {timeStructureValue.startTime !== "" && (
                    <div className="school-structure-table-time-line-data">
                      -
                    </div>
                  )}
                </td>
                <td className="school-structure-table-end-time">
                  {timeStructureValue.startTime !== "" && (
                    <div className="school-structure-table-time-box">
                      <select className="school-structure-table-time-dropdown">
                        {Time.map((timeValue, timeIndex) => {
                          return (
                            <option value={timeValue.time} key={timeIndex}>
                              {timeValue.time}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  )}
                </td>
                <td className="school-structure-table-add-opening-hrs">
                  {timeStructureValue.add}
                </td>
              </tr>
            );
          })}
        </table>
      </div>
      <br />
      <hr />
      <br />
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
            <div>
              <p className="input-heading">Time/Section</p>
              <input type="text" className="input" placeholder="Time/Section" />
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
            <div>
              <p className="input-heading">Section /day</p>
              <input
                type="number"
                className="input"
                placeholder="Section /day"
              />
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
            <div>
              <p className="input-heading">Subject/day</p>
              <input
                type="number"
                className="input"
                placeholder="Subject/day"
              />
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
            <div>
              <p className="input-heading">Break time</p>
              <input type="number" className="input" placeholder="Break time" />
            </div>
          </Grid>
        </Grid>
      </Box>
      <br />
      <br />
      <hr />
      <br />
      <h1 className="school-structure-heading">Add class and division</h1>
      <div className="school-structure-table-container">
        <table>
          <thead>
          <tr>
            <td id="school-structure-add-class-table-class-heading">Class</td>
            <td id="school-structure-add-class-table-no-of-division-heading">
              No. of Division
            </td>
            <td id="school-structure-add-class-table-formate-of-division-heading">
              Formate of Division
            </td>
            <td id="school-structure-add-class-table-division-heading">
              Divisions
            </td>
          </tr>
          </thead>
          <br />
          {AddClassTable.map((addClassTableValue, addClassTableIndex) => {
            return (
              <tr key={addClassTableIndex}>
                <td>
                  <div className="school-structure-add-class-table-class-data">
                    {addClassTableValue.class}
                  </div>
                </td>
                <td>
                  <div className="school-structure-add-class-table-no-of-division-data">
                    {addClassTableValue.divisionNo}
                  </div>
                </td>
                <td className="school-structure-add-class-table-formate-of-division-data">
                  <div>{addClassTableValue.divisionFormate}</div>
                </td>
                <td>
                  <div className="school-structure-add-class-table-division-data">
                    {addClassTableValue.divisions.map(
                      (divisionsValue, divisionsIndex) => {
                        return (
                          <div
                            className="school-structure-add-class-table-division-tags"
                            key={divisionsIndex}
                          >
                            <Chip
                              label={divisionsValue}
                              onDelete={handleDelete(divisionsValue)}
                            />
                          </div>
                        );
                      }
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </table>
      </div>
      <br />

      <Model
        modelTitle="Add class and division"
        onClose={() => setAddClassModel(false)}
        open={addClassModel}
        buttonTitle="add"
        buttonHandler={AddClassHandler}
        loading={addClassLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Class</p>
                  <input
                    type="text"
                    name="class"
                    className="input"
                    placeholder="Class"
                    value={classTitle}
                    ref={classTitleRef}
                    onChange={(e) => setClassTitle(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">No. of Division</p>
                  <input
                    type="number"
                    name="division"
                    className="input"
                    placeholder="No. of Division"
                    value={classDivision}
                    ref={classDivisionRef}
                    onChange={(e) => setClassDivision(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Formate of Division</p>
                  <input
                    type="text"
                    name="formate"
                    className="input"
                    placeholder="Formate of Division"
                    value={classDivisionFormate}
                    ref={classDivisionFormateRef}
                    onChange={(e) => setClassDivisionFormate(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Division</p>
                  <MultiSelect
                    options={options}
                    value={selected}
                    onChange={setSelected}
                    labelledBy="Select"
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </div>
  );
};
export default SchoolStructure;
